import { RateCalculationType } from "../../types/RateAgreementTenantConfiguration";

interface RateCalculationStrategy {
    calculateRateAmount(completeBalance: number, numberOfRates: number): number;
    calculateNumberOfRates(completeBalance: number, rateAmount: number): number;
}

export class RateAmountOnlyStrategy implements RateCalculationStrategy {
    calculateRateAmount(completeBalance: number, numberOfRates: number) {
        return this.roundDownToTwoDecimalPlaces(completeBalance / numberOfRates);
    }

    calculateNumberOfRates(completeBalance: number, rateAmount: number) {
        return Math.floor(completeBalance / rateAmount);
    }

    private roundDownToTwoDecimalPlaces(value: number) {
        return Math.floor(value * 100) / 100;
    }
}

export class DefaultStrategy implements RateCalculationStrategy {
    calculateRateAmount(completeBalance: number, numberOfRates: number) {
        return Math.floor(completeBalance / numberOfRates);
    }

    calculateNumberOfRates(completeBalance: number, rateAmount: number) {
        return Math.floor(completeBalance / rateAmount);
    }
}

export const getStrategy = (type?: RateCalculationType): RateCalculationStrategy => {
    if (!type) {
        throw new Error("Missing RateCalculationType");
    }

    switch (type) {
        case RateCalculationType.RATE_AMOUNT_ONLY:
            return new RateAmountOnlyStrategy();
        default:
            return new DefaultStrategy();
    }
};
